<template>
  <a-layout class="ant-layout layout tablet">
    <!-- SideMenu -->
    <a-layout class="ant-layout topmenu content-width-Fluid" style="padding-left: 0px; min-height: 100vh;">
      <!-- layout header -->
      <!-- <global-header ref="header" style="z-index: 1000;"></global-header> -->
      <!-- layout content -->
      <a-layout-content style="height: 100%;overflow: hidden;">
        <transition name="page-transition">
          <router-view @changeTab="changeTab"/>
        </transition>
      </a-layout-content>

      <!-- layout footer -->
      <a-layout-footer>
        <global-footer />
      </a-layout-footer>

      <!-- Setting Drawer (show in development mode) -->
    </a-layout>
  </a-layout>

</template>

<script>
import GlobalHeader from '@/components/GlobalHeader'
import GlobalFooter from '@/components/GlobalFooter'

export default {
  name: 'BasicLayout',
  components: {
    GlobalHeader,
    GlobalFooter
  },
  data () {
    return {

    }
  },
  computed: {

  },
  watch: {

  },
  created () {

  },
  mounted () {

  },
  methods: {
    changeTab(){
      this.$refs.header.setIndex()
    }
  }
}
</script>

<style lang="less">
/*
 * The following styles are auto-applied to elements with
 * transition="page-transition" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the page transition by editing
 * these styles.
 */

.page-transition-enter {
  opacity: 0;
}

.page-transition-leave-active {
  opacity: 0;
}

.page-transition-enter .page-transition-container,
.page-transition-leave-active .page-transition-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
.ant-layout-content{
  margin: 0;
}
</style>
